import YhForm from './src/form.vue'

export * from './types'
export default YhForm
